/**
 * Money conversion constants
 * Used for converting between cents (integer storage) and dollars (decimal display)
 */

export const CENTS_TO_DOLLARS = 0.01;
export const DOLLARS_TO_CENTS = 100;

